function warning(condition: any, message: string) {
  if (process.env.NODE_ENV !== 'production') {
    if (condition) {
      return;
    }

    const text = `Warning: ${message}`;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {} // eslint-disable-line no-empty
  }
}

export default warning;
